export default __webpack_public_path__ + "static/logo_cooperation_wohnkantine-2bc0ab4da77de00b2f85a3a9871208dd.svg";